import { render } from "./App.vue?vue&type=template&id=13da1230"
const script = {}

import "./App.vue?vue&type=style&index=0&id=13da1230&lang=less"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__